webpackJsonp([3],{

/***/ 182:
/***/ (function(module, exports) {

module.exports = {"ronda-1":"Round 1","ronda-2":"Round 2","ronda-3":"Round 3","instrucciones":"Instructions"}

/***/ })

});


// WEBPACK FOOTER //
// static/js/3.0d17a41ca5c08ccd2970.js